export default __webpack_public_path__ + "static/media/added-watchlist-black.d24c0c6a.svg";